// extracted by css-extract-rspack-plugin
export default {"container":"src-app-components-layout-CircleBadge-CircleBadge-module__container-k2e7Ff"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"container\":\"src-app-components-layout-CircleBadge-CircleBadge-module__container-k2e7Ff\"}";
        // 1789362522803
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  